import { CapoPlugin } from "/home/runner/work/wdd/wdd/frontend/wdd/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];